<template>
    <v-row v-if="!$store.getters.progress && loaded" class="ma-0 pb-offset">
        <v-col cols="12" class="pa-0">
			<crud
				title='Componenti'
				:entity-title='entityTitle'
				action-icon='category'
				model-def='componentproduct'
				action-position='absolute'
                :sub-filters="subFilters"
                :default-input='{product_id: id}'
				crud-dialog
			></crud>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'components-product',
        props: {
            id: Number,
            entityTitle: String
        },

        data() {
            return {
                subFilters: {products: this.id},
                product: {},
                loaded: false
            }
        },

        watch: {
            id: {
                handler() {
                    this.initialize()
                },
                immediate: true,
            },
        },

        methods: {
            initialize() {
                this.axios.get('products/' + this.id + '?lite=true').then(response => {
                    this.$set(this, 'product', response.data.model)
                    this.$store.commit('endProgress')
                    this.loaded = true

                }, response => {
                    // error callback
                })
            },
        }
    }
</script>

<style>

</style>
